export default __webpack_public_path__ + "static/media/video-thumbnail.2561df91.jpg";